export function useFile() {
    function downloadCsv(data: string, filename: string = 'export.csv') {
        try {
            const blob = new Blob([data], { type: 'text/csv' })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        } catch (error) {
            console.error('Error downloading CSV:', error)
        }
    }

    return {
        downloadCsv,
    }
}
